var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex float-left vertical-center"},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.downloadFileConfig.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.filename))])])}
var staticRenderFns = []

export { render, staticRenderFns }